import { jsx } from "react/jsx-runtime";
import { languageMap } from "../../../constants/language.js";
import { Link } from "@nxt-costco-com/forge-components";
import { FontWeightBold } from "@nxt-costco-com/forge-design-tokens";
import { Analytics } from "../../Analytics/index.js";
import { CostcoBox } from "../../Util/CostcoBox.js";
import { LinkText } from "./LinkText.js";
function TextOnly({
  entry,
  externalLinkData,
  insideFlyout = false,
  sx,
  target
}) {
  var _a, _b, _c;
  if (!entry) return null;
  const hasExternalLinkWarning = ((_a = entry.link) == null ? void 0 : _a.external_site) ? true : false;
  const isPreserveSearchParms = !!entry.preserve_url_params;
  const {
    warningPrimaryButtonText,
    warningCloseButtonAriaLabelText,
    warningSecondaryButtonText,
    warningText,
    warningTitle
  } = externalLinkData || {};
  const parseEntryLangId = ({ link = { url: "" } }) => {
    const [_, langId] = /langId=(-?\d*)/g.exec(link == null ? void 0 : link.url) ?? [];
    return languageMap[langId] ?? "en-us";
  };
  const lang = parseEntryLangId(entry);
  return /* @__PURE__ */ jsx(
    Analytics,
    {
      analyticData: {
        component: {
          trackedData: [entry.link.title]
        }
      },
      children: /* @__PURE__ */ jsx(
        Link,
        {
          sx: insideFlyout ? {
            // Prevent font-weight layout shift by allocating enough space in the before element
            "&::before": {
              content: `"${entry.link.title}"`,
              display: "block",
              fontWeight: FontWeightBold,
              height: 0,
              overflow: "hidden",
              visibility: "hidden"
            },
            ...sx
          } : { textAlign: "left" },
          "aria-label": entry.link_alt_text,
          dataPrivate: entry == null ? void 0 : entry.disable_third_party_tracking,
          hasExternalLinkWarning,
          href: (_b = entry.link) == null ? void 0 : _b.url,
          lang,
          preserveSearchParams: isPreserveSearchParms,
          target,
          uniqueId: (_c = entry.link) == null ? void 0 : _c.title,
          warningCloseAriaLabel: warningCloseButtonAriaLabelText,
          warningPrimaryButtonText,
          warningSecondaryButtonText,
          warningText,
          warningTitle,
          children: /* @__PURE__ */ jsx(CostcoBox, { children: /* @__PURE__ */ jsx(LinkText, { entry }) })
        }
      )
    }
  );
}
export {
  TextOnly
};
